<template>
    <div class="mb-6">
        <h4 class="text-slate-800 dark:text-slate-100 text-base font-medium mb-4">
            Details
        </h4>
        <div class="space-y-4">
            <div class="flex items-center gap-3">
                <Icon
                    icon="user"
                    :width="16"
                    :height="16"
                    class="text-slate-400"
                />
                <span class="text-sm text-slate-500 dark:text-slate-400 w-32">User</span>
                <span class="text-sm text-slate-800 dark:text-slate-100">
                    {{ user?.name || 'Unknown' }}
                </span>
            </div>
            <div class="flex items-center gap-3">
                <Icon
                    icon="refresh"
                    :width="16"
                    :height="16"
                    class="text-slate-400"
                />
                <span class="text-sm text-slate-500 dark:text-slate-400 w-32">
                    Update type
                </span>
                <span class="text-sm text-slate-800 dark:text-slate-100">
                    {{ updateType }}
                </span>
            </div>
            <div class="flex items-center gap-3">
                <Icon
                    icon="history"
                    :width="16"
                    :height="16"
                    class="text-slate-400"
                />
                <span class="text-sm text-slate-500 dark:text-slate-400 w-32">
                    Last updated
                </span>
                <span class="text-sm text-slate-800 dark:text-slate-100">
                    {{ lastUpdated }}
                </span>
            </div>
            <div
                v-if="program.connected && program.bank"
                class="flex items-center gap-3"
            >
                <Icon
                    icon="bank-financial"
                    :width="16"
                    :height="16"
                    class="text-slate-400"
                />
                <span class="text-sm text-slate-500 dark:text-slate-400 w-32">
                    Connected Bank
                </span>
                <span
                    class="flex items-center gap-2 text-sm text-slate-800 dark:text-slate-100"
                >
                    <img
                        :src="program.bank?.institution?.small_logo_url"
                        :alt="program.bank.name"
                        class="h-6"
                    />
                    {{ program.bank.name }}
                </span>
            </div>
            <div class="flex items-center gap-3">
                <Icon
                    icon="calendar"
                    :width="16"
                    :height="16"
                    class="text-slate-400"
                />
                <span class="text-sm text-slate-500 dark:text-slate-400 w-32">Added</span>
                <span class="text-sm text-slate-800 dark:text-slate-100">
                    {{ addedDate }}
                </span>
            </div>
        </div>
    </div>
</template>

<script setup>
import Icon from '@/components/ui/icon/icon.vue';

const props = defineProps({
    program: {
        type: Object,
        required: true,
    },
    user: {
        type: Object,
        default: null,
    },
    updateType: {
        type: String,
        required: true,
    },
    lastUpdated: {
        type: String,
        required: true,
    },
    addedDate: {
        type: String,
        required: true,
    },
});
</script>
